import type { CSSProperties } from "react";
import type { HomeInsight, HomeInsightTone } from "../homeShellData";
import HomeTextAction from "./homeTextAction";

const toneClassName: Record<HomeInsightTone, string> = {
    high: "k-text-danger",
    medium: "k-text-brand-warning",
    opportunity: "k-text-brand-teal",
    breach: "k-text-purple"
};

const bgClassName: Record<HomeInsightTone, string> = {
    high: "k-bg-brand-danger-subtle",
    medium: "k-bg-brand-warning",
    opportunity: "k-bg-brand-light-teal",
    breach: "k-bg-brand-purple"
};

const toneAccent: Record<HomeInsightTone, string> = {
    high: "var(--destructive)",
    medium: "var(--warning-border-strong)",
    opportunity: "var(--brand-teal)",
    breach: "var(--breach-border)"
};

type HomeInsightCardProps = {
    insight: HomeInsight;
};

const HomeInsightCard = ({ insight }: HomeInsightCardProps) => (
    <div
        className="home-insight-card bg-white rounded-3 shadow-sm px-4 py-3 h-100 d-flex flex-column shadow-md-hover transition-all"
        style={{ "--home-insight-accent": toneAccent[insight.tone] } as CSSProperties}
    >
        <div className="d-flex">
            {insight.eyebrow && (
                <p className={`text-uppercase fw-semibold letter-spacing-wide fs-9 mb-2 px-2 py-1 k-w-fit rounded-1 ${bgClassName[insight.tone]} ${toneClassName[insight.tone]}`}>
                    {insight.eyebrow}
                </p>
            )}
            {insight.eyebrow_sub && (
                <p className="text-uppercase fw-semibold k-text-subtle letter-spacing-wide fs-9 mb-2 px-2 py-1 k-w-fit rounded-1">
                    {insight.eyebrow_sub}
                </p>
            )}
        </div>
        <h3 className="fs-7 fw-semibold mb-2">{insight.title}</h3>
        <p className="fs-8 text-secondary mb-2">{insight.description}</p>
        {insight.impactLabel && insight.impactValue && (
            <p className="fs-8 mb-2 fw-semibold">
                {insight.impactLabel}
                {" "}
                {insight.impactValue}
            </p>
        )}
        {insight.recommendation && (
            <p className="fs-8 mb-0">
                <span className="fw-semibold">Sovra recommends:</span>
                {" "}
                {insight.recommendation}
            </p>
        )}
        <div className="d-flex align-items-center gap-3 mt-auto pt-3">
            {insight.confidence && <span className="fs-8 text-secondary">{insight.confidence}</span>}
            <div className="ms-auto">
                <HomeTextAction>{insight.actionLabel}</HomeTextAction>
            </div>
        </div>
    </div>
);

export default HomeInsightCard;
